var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "massage-record" }, [
    _c("div", { staticClass: "record-header" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "time-tabs" },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.value,
              class: ["tab-btn", { active: _vm.activeTab === tab.value }],
              on: {
                click: function ($event) {
                  return _vm.handleTabChange(tab.value)
                },
              },
            },
            [_vm._v(" " + _vm._s(tab.label) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "record-content" }, [
      _c("div", { staticClass: "left-stats" }, [
        _vm._m(1),
        _c("div", { staticClass: "stat-number" }, [
          _c("span", { staticClass: "number" }, [
            _vm._v(_vm._s(_vm.totalCount)),
          ]),
          _c("span", { staticClass: "unit" }, [_vm._v("次")]),
        ]),
        _c("div", { staticClass: "stat-label" }, [_vm._v("按摩")]),
      ]),
      _c(
        "div",
        { staticClass: "acupoint-list" },
        [
          _vm._l(_vm.displayList, function (acupoint, index) {
            return _c("div", { key: index, staticClass: "acupoint-item" }, [
              _c("div", { staticClass: "acupoint-image" }, [
                acupoint.image
                  ? _c("img", {
                      attrs: { src: acupoint.image, alt: acupoint.name },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("@/assets/icon/zanwu.png"),
                        alt: "",
                      },
                    }),
                acupoint.label
                  ? _c("div", { staticClass: "image-label" }, [
                      _vm._v(_vm._s(acupoint.label)),
                    ])
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "acupoint-count" }, [
                _c("span", { staticClass: "count" }, [
                  _vm._v(_vm._s(acupoint.count)),
                ]),
                _c("span", { staticClass: "count-unit" }, [_vm._v("次")]),
              ]),
              _c("div", { staticClass: "acupoint-name" }, [
                _vm._v(_vm._s(acupoint.name)),
              ]),
            ])
          }),
          _vm.displayList.length === 0
            ? _c("div", { staticClass: "empty-text" }, [_vm._v(" 暂无记录 ")])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-wrapper" }, [
      _c("div", { staticClass: "title-bar" }),
      _c("h3", { staticClass: "title" }, [_vm._v("按摩记录")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "massage-icon" }, [
      _c("div", { staticClass: "icon-circle" }, [
        _c("img", {
          staticStyle: { width: "60px" },
          attrs: { src: require("@/assets/icon/anmo.png"), alt: "" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }